import "./pwc-header-menu.js";
import { P as v } from "../pwc-element-CZs0VuUW.js";
import { x as m, c as w } from "../lit-element-8JrrHldg.js";
import { r as y } from "../state-D4BCZ2JK.js";
import { p as i } from "../pwcProperty-CTLG9yrF.js";
async function L(t) {
  const s = {
    dev: "https://auth-dev.test.ecoonline.cloud",
    test: "https://auth.test.ecoonline.net",
    stage: "https://auth.stage.ecoonline.net",
    prod: "https://auth.ecoonline.net"
  };
  try {
    const o = s[t] || s.prod, r = { credentials: "include" }, e = (f) => f.json(), a = await fetch(`${o}/platform/userdata`, r).then(e), { authenticated: n, links: p } = a.data;
    return n ? a : await fetch(p.platform_userdata, r).then(e);
  } catch (o) {
    return o;
  }
}
let H = class extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M13 15H7a1 1 0 0 1-1-1v-1.5h1V14h6V2H7v1.5H6V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1Z"></path><path d="M7.295 10.295 9.085 8.5H2v-1h7.085l-1.79-1.795L8 5l3 3-3 3-.705-.705Z"></path></svg>';
  }
};
const h = "pi-login";
customElements.get(h) || customElements.define(h, H);
let x = class extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="m3.644 11.646 3.999-3.998.707.707-3.999 3.998-.707-.707ZM8.5 15a.499.499 0 0 1-.495-.43l-.5-3.5 1-.14.375 2.635 1.62-1.305V8.5a.5.5 0 0 1 .145-.355L12.68 6.11A4.47 4.47 0 0 0 14 2.93V2h-.93a4.47 4.47 0 0 0-3.18 1.32L7.855 5.355A.5.5 0 0 1 7.5 5.5H3.74L2.435 7.13l2.635.375-.14 1-3.5-.5a.5.5 0 0 1-.32-.81l2-2.5A.5.5 0 0 1 3.5 4.5h3.795L9.18 2.61A5.46 5.46 0 0 1 13.07 1H14a1 1 0 0 1 1 1v.93a5.46 5.46 0 0 1-1.61 3.89L11.5 8.705V12.5a.5.5 0 0 1-.19.39l-2.5 2a.5.5 0 0 1-.31.11Z" clip-rule="evenodd"></path></svg>';
  }
};
const u = "pi-rocket";
customElements.get(u) || customElements.define(u, x);
class P extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8.306 1.607a.505.505 0 0 0-.621 0L.5 7.21l.621.786L2 7.31v6.19a1.002 1.002 0 0 0 1 1h10a1.002 1.002 0 0 0 1-1V7.315l.879.685.621-.786-7.194-5.607ZM9 13.5H7v-4h2v4Zm1 0v-4a1.001 1.001 0 0 0-1-1H7a1.001 1.001 0 0 0-1 1v4H3V6.53l5-3.894 5 3.9V13.5h-3Z"></path></svg>';
  }
}
const d = "pi-home";
customElements.get(d) || customElements.define(d, P);
var E = Object.defineProperty, I = Object.getOwnPropertyDescriptor, c = (t, s, o, r) => {
  for (var e = r > 1 ? void 0 : r ? I(s, o) : s, a = t.length - 1, n; a >= 0; a--)
    (n = t[a]) && (e = (r ? n(s, o, e) : n(e)) || e);
  return r && e && E(s, o, e), e;
};
const g = "pwc-header-app-launcher";
let l = class extends v {
  constructor() {
    super(...arguments), this.menuItems = [];
  }
  async firstUpdated() {
    super.firstUpdated();
    try {
      const t = await L(this.env);
      if (t.data) {
        const { authenticated: s, token: o, applications: r, links: e } = t.data;
        if (s) {
          const a = r.map((n) => {
            const p = n.links.go.includes("?") ? "&" : "?";
            return {
              label: n.displayName ?? n.name,
              iconPath: n.icon,
              href: `${n.links.go}${p}token=${o}`
            };
          });
          e.homepage && a.push({
            label: "Platform",
            icon: "home",
            href: e.homepage
          }), this.menuItems = a;
        } else
          this.menuItems = [
            {
              label: this.loginText,
              href: e.login,
              icon: "login"
            }
          ];
      } else
        this.menuItems = [];
    } catch {
      this.menuItems = [];
    }
  }
  render() {
    return m`
      <pwc-header-menu
        label=${this.label}
        .menuItems=${this.menuItems}
        icon="rocket"
      >
        <pwc-template p-slot="menuContent">
          ${this.menuItems.length ? null : m`<div class="PwcHeaderAppLauncher__error">
                ${this.errorText}
              </div>`}
        </pwc-template>
      </pwc-header-menu>
    `;
  }
};
l.tagName = g;
c([
  i({ type: String, default: "App Launcher" })
], l.prototype, "label", 2);
c([
  i({ type: String, default: "Log in to EcoID" })
], l.prototype, "loginText", 2);
c([
  i({
    type: String,
    default: "An error occurred. Please try reloading the page and contact us if the issue persists."
  })
], l.prototype, "errorText", 2);
c([
  i({ type: String, default: "prod" })
], l.prototype, "env", 2);
c([
  y()
], l.prototype, "menuItems", 2);
l = c([
  w(g)
], l);
export {
  l as PwcHeaderAppLauncher
};
